<template>
  <div class="content">
    <div class="container-fluid">
      <card>
        <h4 class="mt-0">Sizden Gelenler İncele</h4>

        <div class="row">
          <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
            <div class="input-group-prepend">
              <div class="d-flex justify-content-center align-items-center">
              <span class="input-group-text">Ad Soyad :</span>
              <span class="ml-3"> {{post.name}}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
            <div class="input-group-prepend">
              <div class="d-flex justify-content-center align-items-center">
              <span class="input-group-text">Email :</span>
              <span class="ml-3"> {{post.link}}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
            <div class="input-group-prepend">
              <div class="d-flex justify-content-center align-items-center">
              <span class="input-group-text">Telefon Numarası :</span>
              <span class="ml-3"> {{post.subtitle}}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
            <div class="input-group-prepend">
              <div class="d-flex justify-content-center align-items-center">
              <span class="input-group-text">Mesaj :</span>
              <span class="ml-3"> {{content.content}}</span>
              </div>
            </div>
          </div>
          <div v-if="post.newvideo !=0" class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
            <div v-if="post.newvideo==1" class="input-group-prepend">
              <div class="d-flex flex-column">
              <span class="input-group-text d-flex align-items-center justify-content-center">Video</span>
             <youtube :video-id="post.newvideo_id"></youtube>
              </div>
            </div>
            <div v-if="post.newvideo==2" class="input-group-prepend">
              <div class="d-flex flex-column">
              <span class="input-group-text d-flex align-items-center justify-content-center">Resim</span>
              <img :src="generalURL('sizdengelenler')+post.image" alt="">
              </div>
            </div>
          </div>



        </div>

      </card>
    </div>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
export default {
  data: function() {
    return {
      id: this.$route.params.id,

      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: "ComingFromYou",
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: "title",
            meta_value: null
          },
          meta3: {
            meta_key: "description",
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      croppieType: "main",
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      firstSlider: false
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {


    getInitialData: function() {
      this.toggleLoader();
      this.$http.get("/api/posts/get/" + this.id).then(
        response => {
          this.post = response.body;
          this.content = this.post.content;
          this.toggleLoader();
        },
        er => {
          this.toggleLoader();
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          return;
        }
      );
    },

  },
  mounted: function() {
    this.getInitialData()
  }
};
</script>
<style>

.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/ComingFromYou/Edit.vue